/* tslint:disable */
/* eslint-disable */
export enum PatientTargetStatus {
  Ready = 1,
  Baseline = 2,
  Aquisition = 4,
  Mastered = 5,
  Maintenance = 6,
  Closed = 8,
  On_Hold = 9,
  Fluent = 10
}
